export default "__VITE_ASSET__CqVyzn1V__"